import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { accountsMiddleware, accountsReducer } from "./accounts/accounts";
import { authMiddleware, authReducer } from "./auth/auth";
import { currentAccountReducer } from "./current-account/current-account";
import { dialogsReducer } from "./dialogs/dialogs";
import { menuMiddleware, menuReducer } from "./menu/menu";
import { notificationsReducer } from "./notifications/notifications";
var rootReducer = combineReducers({
    accounts: accountsReducer,
    auth: authReducer,
    currentAccount: currentAccountReducer,
    dialogs: dialogsReducer,
    menu: menuReducer,
    notifications: notificationsReducer
});
export var setupStore = function(preloadedState) {
    return configureStore({
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware().concat(authMiddleware).concat(accountsMiddleware).concat(menuMiddleware);
        },
        preloadedState: preloadedState,
        reducer: rootReducer
    });
};

//# sourceMappingURL=store.js.map